import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=821e7f84&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./contactUs.css?vue&type=style&index=0&id=821e7f84&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821e7f84",
  null
  
)

export default component.exports